module.exports = __webpack_public_path__ + "img/45000.c468fac1.jpg";